import { post, get, put } from '../utils/request'
export default {
  // 微信公众号
  getNtas: (data) => get('/jssdk/getNtas', data), // 获取JSSDK
  wechatAuthorize: (data) => get('/wechat/authorize', data), // 获取用户信息
  wechatUserInfo: (data) => get('/wechat/userInfo', data), // 获取用户信息
  /* 我的就诊人 */

  sendSmsCode: (data) => get('/api/patient/sendTxVerificationCode', data), // 发送短信验证码
  validateSmsCode: (data) => get('/api/patient/sendTxVerificationCodeIsTrue', data), // 校验短信验证码

  getByAppletsId: (data) => get('/api/patient/getByAppletsId', data), // 获取用户信息
  addPatient: (data) => post('/api/patient/addPatient', data), // 新增患者信息
  updPatient: (data) => post('/api/patient/updPatient', data), // 新增患者信息
  delPatient: (data) => post('/api/patient/delPatient', data), // 解绑患者信息
  updatePatient: (data) => post('/api/patient/updatePatient', data), // 设置默认就诊人
  getPatientListVo: (data) => get('/api/patient/getPatientListVo', data), // 获取就诊人列表
  getPatientInfo: (data) => get('/api/patient/getPatient', data), // 获取就诊人详情
  patientList: (data) => get('/api/patient/list', data), // 患者信息
  adAdministrativeRegionVoList: (data) => get('/administrativeregion/adAdministrativeRegionVoList', data), // 行政区划(下拉)
  /* 预约挂号 */
  getAdminList: (data) => post('/admin/list', data), // 获取科室
  deptTree: (data) => get('/api/dept/tree', data), // 根据父节点获取部门树结构
  deptList: (data) => get('/api/dept/list', data), // 部门列表搜索
  getKeepRange: (data) => post('/api/keep/getKeepRange', data), // 医师日期 能否挂号
  findByKeyword: (data) => get('/api/keep/findByKeyword', data), // 医生科室搜索 传参搜医生与科室 不传参搜科室
  registerPage: (data) => get('/api/register/registerPage', data), // 就诊记录分页
  registerDetail: (data) => get(`/api/register/detail/${data.id}`), // 挂号详情
  getKeeps: (data) => get('/api/keep/gjyy/getKeeps', data), // 科室排班
  getKeepsNum: (data) => get('/api/keep/gjyy/getKeepsNum', data), // 所有日期排版
  getKeep: (data) => get('/api/keep/getKeep', data), // 科室排班
  getDoctorList: (data) => get('/api/doctor/gjyy/getDoctorList', data), // 科室查医生
  appointment: (data) => post('/api/register/appointment', data), // 挂号
  registerCancel: (data) => put('/api/register', data), // 取消挂号
  /* 医院信息 */
  getDept: (data) => get('/newapi/api/dept/getDept', data), // 科室介绍
  getGuidebook: (data) => get('/api/guidebook/getGuidebook', data), // 获取就医指南
  hospital: (data) => get('/api/hospital/hospital/one/1', data), // 获取医院介绍
  /* 报告查询 */
  getInspectReport: (data) => post('/api/inspection/inspect/szsxcgjyy/getInspectReport', data), // 检验报告列表
  getGjyyReportList: (data) => get('/api/inspection/inspection/gjyy/getReportList', data), // 检验报告列表
  getReportDetail: (data) => get('/api/inspection/inspection/gjyy/getReportDetail', data), // 检验报告详情
  getEinvoiceDetailsById: (data) => get('/api/chargeDetail/getEinvoiceDetailsById', data), // 获取电子发票
  /* 缴费 */
  gjyyPay: (data) => put('/api/chargeInfo/gjyy/pay', data), // 支付
  chargeListPage: (data) => get('/api/chargeInfo/chargeListPage', data), // 门诊缴费列表
  getChargeDetailsByClinicNo: (data) => get('/api/chargeDetail/getChargeDetailsByClinicNo', data), // 缴费明细
  /* 预检分诊表 */
  precheckGetList: (data) => get('/api/precheck/getList', data),
  precheckAdd: (data) => post('/api/precheck', data),
  precheckDetail: (data) => get(`/api/precheck/one/${data.id}`),
  detailInit: (data) => get('/api/precheck/detailInit', data), // 查询患者有没有填写过预检分诊
  precheckPatientList: (data) => get('/api/precheck/patientList', data), // 获取填写人列表
  getListByPatientId: (data) => get('/api/precheck/getListByPatientId', data), // 获取患者有没有填写预检分诊表
  addPatientRemark: (data) => post('patientRemark/addPatientRemark', data), // 患者留言-添加
  /* 医生介绍 */
  getDoctor: (data) => get('/api/doctor/getSzsgjyyDoctorList', data), // 科室查医生
  getDoctorInfo: (data) => get('/api/doctor/getSzsgjyyDoctorInfo', data), // 医生介绍详情
  /* 住院 */
  addPatientZyBinding: (data) => post('/api/patientzybinding/addPatientZyBinding', data), // 添加患者住院人绑定
  updPatientZyBinding: (data) => post('/api/patientzybinding/updPatientZyBinding', data), // 修改患者住院人绑定
  delPatientZyBindingByID: (data) => get(`/api/patientzybinding/delPatientZyBindingByID/${data}`), // 删除住院人绑定信息
  getPatientZyBindingByID: (data) => get(`/api/patientzybinding/getPatientZyBindingByID/${data}`), // 查看住院人绑定信息
  getPatientZyBindingList: (data) => get(`/api/patientzybinding/getPatientZyBindingList/${data}`), // 患者住院人绑定列表
  getPatientZyInfo: (data) => post('/api/patientzy/getPatientZyInfo', data), // 获取住院费用清单
  getZyInspectionReportInfo: (data) => post('/api/patientzy/getZyInspectionReportInfo', data), // 获取住院费用清单
  getZYPaymentInAdvanceInfo: (data) => post('/api/patientzy/getZYPaymentInAdvanceInfo', data), // 获取预交金缴费记录
  getZYPatientZyExamineInfo: (data) => post('/api/patientzy/getZYPatientZyExamineInfo', data), // 住院检查报告
  getZYPatientZyReport: (data) => get('/api/patientzy/getZYPatientZyReport', data), // 住院检查报告
  getZYPatientZyReportDetail: (data) => get('/api/patientzy/getZYPatientZyReportDetail', data), // 获取住院检验报告详情
  zyPay: (data) => post('/api/patientzy/zyPay', data), // 住院费用缴纳(小马哥支付)
  getSzsgjyyDoctorJobList: (data) => get('/api/doctor/getSzsgjyyDoctorJobList', data), // 职称列表-苏州市广济医院
  getSzsgjyyDoctorJobTitleInfo: (data) => get('/api/doctor/getSzsgjyyDoctorJobTitleInfo', data), // 职称列表-苏州市广济医院
  getGjyyDoctorKeeps: (data) => get('/api/keep/gjyy/getGjyyDoctorKeeps', data), // 职称列表-苏州市广济医院
  // 孕检心身
  addPregnancyQuestionnaire: (data) => post('/pregnancy/pregnancyQuestionnaires/addPregnancyQuestionnaires', data),
  getPregnancyQuestionnaireInfo: (data) => get('/pregnancy/pregnancyQuestionnaires/getInfo', data)
}
